import React, {useCallback} from 'react'
import PropTypes from 'prop-types'
import i18next from 'i18next'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'
import {Button} from '@chakra-ui/react'

const BillActionButton = ({bill, width}) => {
  i18next.loadNamespaces('pointsOnPayments')
  const {t} = useTranslation()
  const navigate = useNavigate()
  const isDisabled = !bill.canPay

  const handleOnClick = useCallback(
    (e) => {
      if (isDisabled) {
        e.preventDefault()
      } else {
        navigate(`/points_on_payments/payments/${bill.id}`)
      }
    },
    [isDisabled, navigate, bill.id],
  )

  return (
    <Button
      variant="secondary"
      size="sm"
      disabled={isDisabled}
      onClick={handleOnClick}
      width={width}
    >
      {t('pointsOnPayments:bill.table.callToActions.payBill')}
    </Button>
  )
}

BillActionButton.defaultProps = {
  width: undefined,
}

BillActionButton.propTypes = {
  bill: PropTypes.shape({
    id: PropTypes.string.isRequired,
    canPay: PropTypes.bool.isRequired,
  }).isRequired,
  width: PropTypes.string,
}

export default BillActionButton
